// /* eslint-disable react/prop-types */
// import React from "react";
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import { Tabs, Tab, IconButton } from "@mui/material";
// import Icon from "@mui/material/Icon";
// import { useNavigate } from "react-router-dom";
// import { useSoftUIController, setMiniSidenav } from "context";
// import borders from "assets/theme/base/borders";

// const MainHeader = ({
//   activeTopTab,
//   setActiveTopTab,
//   activeDataTab,
//   setActiveDataTab,
// }) => {
//   const [controller, dispatch] = useSoftUIController();
//   const { miniSidenav } = controller;

//   const topTabs = ["My Data", "Team"];
//   const subTabs = ["Leave Summary", "Leave Balance", "Leave Request", "My Request"];

//   const handleTopTabChange = (tab) => {
//     setActiveTopTab(tab);
//     if (tab === "Team") {
//       setActiveDataTab("Team List");
//     } else if (tab === "My Data") {
//       setActiveDataTab("Leave Summary");
//     }
//   };

//   const handleSubTabChange = (event, newValue) => {
//     setActiveDataTab(newValue);
//   };

//   const handleMiniSidenavToggle = () => {
//     setMiniSidenav(dispatch, !miniSidenav);
//   };

//   return (
//     <SoftBox sx={{ position: "sticky", top: 89, zIndex: 1000,borderRadius : "10px" }}>
//       {/* Top Tab Header */}
//       <SoftBox
//         display="flex"
//         alignItems="center"
//         px={3}
//         py={2}
//         sx={{
//           background: "linear-gradient(87deg, rgb(41, 88, 182) 0, rgb(40, 62, 152) 100%)",
//           boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
//         borderRadius : "10px"
//         }}
//         justifyContent="space-between"
//       >
//         {/* Top Tabs */}
//         <SoftBox display="flex" gap={3}   sx={{
//         borderRadius : "10px"
//         }}>
//           {topTabs.map((tab) => (
//             <SoftTypography
//               key={tab}
//               onClick={() => handleTopTabChange(tab)}
//               variant="h6"
//               fontWeight="bold"
//               sx={{
//                 color: activeTopTab === tab ? "#fff" : "rgba(255, 255, 255, 0.8)",
//                 borderBottom: activeTopTab === tab ? "2px solid #00c2ff" : "none",
//                 cursor: "pointer",
//                 transition: "all 0.2s ease-in-out",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   color: "#fff",
//                   backgroundColor: "rgba(255, 255, 255, 0.1)",
//                 },
//               }}
//             >
//               {tab}
//             </SoftTypography>
//           ))}
//         </SoftBox>

//         {/* Mini Sidenav Toggle */}
//         <IconButton
//           size="small"
//           onClick={handleMiniSidenavToggle}
//           sx={{ 
//             color: "#fff",
//             "&:hover": {
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             }
//           }}
//         >
//           <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
//         </IconButton>
//       </SoftBox>

//       {/* Sub Tabs for My Data */}
//       {activeTopTab === "My Data" && (
//         // <SoftBox
//         //   sx={{ 
//         //     backgroundColor: "#fff", 
//         //     borderBottom: "1px solid #e0e0e0",
//         //     boxShadow: "0 2px 4px -1px rgba(0, 0, 0, 0.1)",
//         //     position: "sticky",
//         //     top: "64px", // Adjust based on your top header height
//         //     zIndex: 999
//         //   }}
//         //   px={3}
//         // >
//           <Tabs
//           sx={{marginTop : "10px"}}
//             value={activeDataTab}
//             onChange={handleSubTabChange}
//             textColor="info"
//             indicatorColor="primary"
//             // sx={{ 
//             //   minHeight: "48px",
//             //   "& .MuiTabs-indicator": {
//             //     backgroundColor: "#00c2ff",
//             //     height: "3px",
//             //   }
//             // }}
//           >
//             {subTabs.map((tab) => (
//               <Tab
//                 key={tab}
//                 value={tab}
//                 label={
//                   <SoftTypography
//                     fontSize="0.875rem"
//                     fontWeight="medium"
//                     color="text"
//                     sx={{
//                       transition: "all 0.2s ease-in-out",
//                     }}
//                   >
//                     {tab}
//                   </SoftTypography>
//                 }
//                 // sx={{
//                 //   textTransform: "none",
//                 //   minHeight: "48px",
//                 //   padding: "8px 16px",
//                 //   marginRight: 1,
//                 //   fontSize: "0.95rem",
//                 //   "&.Mui-selected": {
//                 //     color: "#1976d2",
//                 //   },
//                 //   "&:hover": {
//                 //     backgroundColor: "rgba(0, 194, 255, 0.04)",
//                 //   },
//                 // }}
//               />
//             ))}
//           </Tabs>
//         // </SoftBox>
//       )}
//     </SoftBox>
//   );
// };

// export default MainHeader;


/* eslint-disable react/prop-types */
import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Tabs, Tab, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import { useSoftUIController, setMiniSidenav } from "context";
import { useAuth } from "AuthContext";
import { filterByPermission } from "permissionUtils";

const MainHeader = ({
  activeTopTab,
  setActiveTopTab,
  activeDataTab,
  setActiveDataTab,
}) => {
  const { userPermission } = useAuth();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;

  /* 🔹 TOP TABS (NO HISTORY HERE) */
  const topTabs = filterByPermission(
    [
      { label: "My Data", permission: "LeaveTracker.MyData" },
      { label: "Team", permission: "LeaveTracker.Team" },
    ],
    userPermission
  );

  /* 🔹 SUB TABS (HISTORY ADDED HERE) */
  const subTabs = filterByPermission(
    [
      {
        label: "Leave Summary",
        permission: "LeaveTracker.MyData.LeaveSummary",
      },
      {
        label: "Leave Balance",
        permission: "LeaveTracker.MyData.LeaveBalance",
      },
      {
        label: "Leave Request",
        permission: "LeaveTracker.MyData.LeaveRequest",
      },
      {
        label: "My Request",
        permission: "LeaveTracker.MyData.MyRequest",
      },
      {
        label: "History",
        permission: "LeaveTracker.Mydata.AllLeaveHistory",
      },
    ],
    userPermission
  );

  const handleTopTabChange = (tab) => {
    setActiveTopTab(tab);

    if (tab === "My Data" && subTabs.length) {
      setActiveDataTab(subTabs[0].label);
    }
  };

  return (
    <SoftBox sx={{ position: "sticky", zIndex: 1000 }}>
      {/* 🔹 TOP HEADER */}
      <SoftBox
        display="flex"
        alignItems="center"
        px={3}
        py={1}
        justifyContent="space-between"
        sx={{
          background:
            "linear-gradient(87deg, rgb(41, 88, 182) 0, rgb(40, 62, 152) 100%)",
          borderRadius: "10px",
        }}
      >
        <SoftBox display="flex" gap={3}>
          {topTabs.map((tab) => (
            <SoftTypography
              key={tab.label}
              onClick={() => handleTopTabChange(tab.label)}
              variant="h6"
              fontWeight="medium"
              sx={{
                color:
                  activeTopTab === tab.label
                    ? "#fff"
                    : "rgba(255,255,255,.8)",
                borderBottom:
                  activeTopTab === tab.label
                    ? "2px solid #00c2ff"
                    : "none",
                cursor: "pointer",
                paddingBottom: "2px",
              }}
            >
              {tab.label}
            </SoftTypography>
          ))}
        </SoftBox>

        <IconButton
          size="small"
          onClick={() => setMiniSidenav(dispatch, !miniSidenav)}
          sx={{ color: "#fff" }}
        >
          <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
        </IconButton>
      </SoftBox>

      {/* 🔹 SUB TABS */}
      {activeTopTab === "My Data" && (
        <Tabs
          sx={{ mt: 1, mb:1.5 }}
          value={activeDataTab}
          onChange={(e, v) => setActiveDataTab(v)}
        >
          {subTabs.map((tab) => (
            <Tab
              key={tab.label}
              value={tab.label}
              label={
                <SoftTypography fontSize="0.875rem" fontWeight="medium" color="text">
                  {tab.label}
                </SoftTypography>
              }
            />
          ))}
        </Tabs>
      )}
    </SoftBox>
  );
};

export default MainHeader;
